export const changeMain_ru = {
    load: 'Обновление',
    positiveResponse: 'Данные вашего профиля успешно изменены',
    positiveResponsePassword: 'Ваш пароль успешно изменён',
    yourNewPassword: 'Новый пароль:',
    negativeResponse: 'Что-то пошло не так',
    repeatRequest: 'Скорее всего изменения в ваших данных уже сохранены',
    linkMainPage: 'Главная страница',
}